import {useEffect} from "react";

import {useAppDispatch} from "../../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../../store/hooks/use_app_selector";
import {resetLastFlowOutcome, selectLastFlowOutcome} from "../../state/user_phone_verification_slice";
import {PhoneVerificationFlowOutcomeKind, PhoneVerificationPendingActionType} from "../types/phone_verification_types";

interface IUsePhoneVerificationActionCompletionOptions {
    actionType: PhoneVerificationPendingActionType;
    onComplete?: () => void;
    onFailure?: () => void;
    onDismissed?: () => void;
    isEnabled?: boolean;
}

export const usePhoneVerificationActionCompletion = ({
    actionType,
    onComplete,
    onFailure,
    onDismissed,
    isEnabled = true
}: IUsePhoneVerificationActionCompletionOptions) => {
    const dispatch = useAppDispatch();
    const lastFlowOutcome = useAppSelector(selectLastFlowOutcome);

    useEffect(() => {
        if (!lastFlowOutcome || lastFlowOutcome.type !== actionType) return;

        dispatch(resetLastFlowOutcome());

        if (!isEnabled) return;

        if (lastFlowOutcome.kind === PhoneVerificationFlowOutcomeKind.DISMISSED) {
            onDismissed?.();
            return;
        }

        if (lastFlowOutcome.success) {
            onComplete?.();
            return;
        }

        onFailure?.();
    }, [actionType, dispatch, isEnabled, lastFlowOutcome, onComplete, onDismissed, onFailure]);
};
import {useEffect} from "react";

import {useAppDispatch} from "../../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../../store/hooks/use_app_selector";
import {resetLastFlowOutcome, selectLastFlowOutcome} from "../../state/user_phone_verification_slice";
import {PhoneVerificationFlowOutcomeKind, PhoneVerificationPendingActionType} from "../types/phone_verification_types";

interface IUsePhoneVerificationActionCompletionOptions {
    actionType: PhoneVerificationPendingActionType;
    onComplete?: () => void;
    onFailure?: () => void;
    onDismissed?: () => void;
    isEnabled?: boolean;
}

export const usePhoneVerificationActionCompletion = ({
    actionType,
    onComplete,
    onFailure,
    onDismissed,
    isEnabled = true
}: IUsePhoneVerificationActionCompletionOptions) => {
    const dispatch = useAppDispatch();
    const lastFlowOutcome = useAppSelector(selectLastFlowOutcome);

    useEffect(() => {
        if (!lastFlowOutcome || lastFlowOutcome.type !== actionType) return;

        dispatch(resetLastFlowOutcome());

        if (!isEnabled) return;

        if (lastFlowOutcome.kind === PhoneVerificationFlowOutcomeKind.DISMISSED) {
            onDismissed?.();
            return;
        }

        if (lastFlowOutcome.success) {
            onComplete?.();
            return;
        }

        onFailure?.();
    }, [actionType, dispatch, isEnabled, lastFlowOutcome, onComplete, onDismissed, onFailure]);
};
